export default __webpack_public_path__ + "static/cercle_vicieux_uw_es-11dacb49d3e15b9b468ac57661300a86.mp4";